import Fingerprint from "lucide-react/dist/esm/icons/fingerprint-pattern.mjs";
import { Brand } from "./Brand";

export function LockedScreen({ busy, offline = false, error, onSignIn }: { busy: boolean; offline?: boolean; error: string; onSignIn: () => void }) {
  return (
    <main className="locked-screen">
      <div className="locked-screen__panel">
        <Brand />
        <div className="locked-screen__copy">
          <h1>Your reading, held quietly.</h1>
          <p>{offline ? "You're offline. No saved reading is available on this device yet. Connect to open your library." : "Open your private Imprint library with the passkey already registered to this account."}</p>
        </div>
        <button className="primary-command" type="button" onClick={onSignIn} disabled={busy || offline}>
          <Fingerprint aria-hidden="true" />
          {busy ? "Waiting for passkey…" : "Continue with passkey"}
        </button>
        {error ? <p className="margin-note" role="alert">{error}</p> : null}
      </div>
    </main>
  );
}
